export default {
  signBook: {},
  signworkflows: {},
  nbSignbooks: undefined,
  searchParams: {
    orders: [
      {
        fieldName: 'creationDate',
        orderBy: 'DESC',
      },
    ],
    params: [
      { paramName: 'status', paramValue: 'inbox' },
      { paramName: 'creationDateStart', paramValue: '' },
      { paramName: 'creationDateEnd', paramValue: '' },
    ],
    offset: 0,
    limit: 20,
  },
  pagination: {
    current: 1,
    total: 1,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/parapheurs/state.js